import React from 'react';
import { useDrop } from 'react-dnd';
import { find } from 'lodash';
import { dndTypes } from '../helpers/constants';
import { TileDropItem, HandState } from '../types';
import { Button } from './Button';

type DumpSectionProps = {
    onDrop: (item: TileDropItem) => void,
    hand: HandState,
};

export const DumpSection: React.FC<DumpSectionProps> = React.memo(({ onDrop, hand }) => {
    const [{ canDrop, isOver }, drop] = useDrop({
        accept: dndTypes.TILE_FROM_HAND,
        drop: (item: TileDropItem) => {
            onDrop(item);
        },
        collect: (monitor) => {
            const item = monitor.getItem();
            const itemIsInHand = !!find(hand, { id: item?.id });
            const canDrop = monitor.canDrop() && itemIsInHand;
            const isOver = monitor.isOver();
            return {
                canDrop,
                isOver,
            };
        },
    });

    return canDrop ? (
        <Button active={isOver} as="div" ref={drop}>
            DUMP
        </Button>
    ) : null;
});

